import VueRouter from "vue-router";
import Root from "./vss_app.vue";
import Dashboard from "@/components/dashboard/index-wrapper.vue";
import ProfileWrapper from "@/components/profile/index-wrapper.vue";
// import Dashboard from './components/dashboard/index'
// TODO: is this insane?
import Calendar from "@/components/calendar/index-wrapper.vue";
import MonthCalendar from "@/components/calendar/month-calendar-index.vue";
import Inbox from "@/components/messages/index.vue";
import Outbox from "@/components/messages/sent.vue";
import Requests from "@/components/messages/requests.vue";
import ClientEvaluationForm from "@/components/client-evaluation/index-wrapper.vue";
import Hr from "@/components/hr/index-wrapper.vue";
import DeactivatedEmployees from "@/components/hr/deactivated-employees.vue";
import EmployeeCreate from "@/components/hr/employee-create-wrapper.vue";
import HrClients from "@/components/hr/client-index-wrapper.vue";
import ClientDetail from "@/components/hr/client-detail.vue";
import ClientCreate from "@/components/hr/client-create-wrapper.vue";
import HrManagers from "@/components/hr/manager-index-wrapper.vue";
import HrManagerDetail from "@/components/hr/manager-detail.vue";
import ClientBusinessCreate from "@/components/hr/client-business-create.vue";
import HrClientBusinesses from "@/components/hr/client-business-index-wrapper.vue";
import clientAdminLocations from "@/components/hr/administered-locations.vue";
import ClientBusinessDetail from "@/components/hr/client-business-detail.vue";
import HrGeotags from "@/components/hr/geotags.vue";
import GeoTagShow from "@/components/hr/geo-tag-show.vue";
import LocationCreate from "@/components/hr/new-location.vue";
import ReportsIndex from "@/components/reports/index.vue";
// import TimeclockReports from './components/reports/timeclock'
import LocationTimeclockReports from "@/components/reports/timeclock-single-location.vue";
import PayrollReports from "@/components/reports/payroll.vue";
import BillingReports from "@/components/reports/billing.vue";
import ClientFulfillmentReport from "@/components/reports/client-fulfillment.vue";
import ClientLocationFulfillmentReport from "@/components/reports/client-location-fulfillment.vue";
import EmployeeShiftCountReport from "@/components/reports/employee-shift-count.vue";
import ManagerFulfillmentReport from "@/components/reports/manager-fulfillment.vue";
import CurrentlyWorkingReport from "@/components/reports/currently-working.vue";
import ClientTimeOrderedReport from "@/components/reports/client-time-ordered.vue";
import AllTimeOrderedReport from "@/components/reports/all-time-ordered.vue";
import EmployeeHoursAtClientReport from "@/components/reports/employee-hours-at-client-report.vue";
import EmployeeHours from "@/components/reports/employee-time-worked-report.vue";
import CancelledShifts from "@/components/reports/cancelled-shifts.vue";
import BirthdaysAnniversaries from "@/components/reports/birthdays-anniversaries-report.vue";
import ContactReport from "@/components/reports/contact-report.vue";
import CertificationsReport from "@/components/reports/certifications-report.vue";
import TaskReport from "@/components/reports/task-report.vue";
import GeoReport from "@/components/reports/geo-report.vue";
import ReferralReport from "@/components/reports/referral-report.vue";
import CommLogReport from "@/components/reports/comm-log-report.vue";
import IPAddressLogReport from "@/components/reports/ipaddress-log-report.vue";

import WatchListIndex from "@/components/hr/watch-list-index.vue";
import WatchListShow from "@/components/hr/watch-list.vue";

// import Hr from './components/hr/index'
import Login from "@/components/login/index.vue";
import LoginAs from "@/components/login/loginAsUser.vue";
import Timeclock from "@/components/timeclock/index.vue";
import ShiftConfirm from "@/components/timeclock/confirm.vue";
import Punch from "@/components/timeclock/punch.vue";
import Resources from "@/components/hr/resources.vue";
import EmployeeDetail from "@/components/hr/employee-detail-wrapper.vue";
import ShiftDetail from "@/components/calendar/shift-detail-wrapper.vue";
import ServiceCreate from "@/components/service/create-wrapper.vue";
import EventIndex from "@/components/event/event-index.vue";
import EventCreate from "@/components/event/event-create.vue";
import EventShow from "@/components/event/event-show.vue";
import ForgotPassword from "@/components/login/forgot-password.vue";
import ResetPassword from "@/components/login/reset-password.vue";
import SettingsIndex from "@/components/settings/index.vue";
import SettingsHolidays from "@/components/settings/holidays.vue";
import SettingsCallin from "@/components/settings/callin.vue";
import SettingsBulletins from "@/components/settings/bulletins.vue";
import WorksiteShow from "@/components/worksites/worksite-show.vue";
import CoordinatedCoverageRequestContainer from "@/components/coordinated-coverage-requests/coordinated-coverage-request-container.vue";

import EmployeeOwnWorkHistory from "@/components/reports/employee-own-work-history.vue";

import MyTodos from "@/components/todos/my-list.vue";
import ManagedTodos from "@/components/todos/managed-lists.vue";
import SMSIndex from "@/components/sms/sms-index.vue";

import store from "./store";

const routes = [
  {
    name: "login",
    path: "/login",
    component: Login,
    meta: { open: true, title: "Vss - Login" },
  },
  {
    name: "loginAs",
    path: "/login_as_user",
    component: LoginAs,
    meta: { open: true, title: "Vss - Login As User" },
  },
  {
    name: "forgotPassword",
    path: "/forgot_password",
    component: ForgotPassword,
    meta: { open: true, title: "Vss - Forgot Password" },
  },
  {
    name: "resetPassword",
    path: "/password_resets/:token",
    component: ResetPassword,
    meta: { open: true, title: "Vss - Reset Password" },
  },
  {
    name: "root",
    path: "/",
    component: Dashboard,
    meta: { title: "Vss - Dashboard" },
  },
  {
    name: "profile",
    path: "/profile",
    component: ProfileWrapper,
    meta: { title: "Vss - My Profile" },
  },
  // Legacy: TODO: remove
  {
    name: "timeclock",
    path: "/timeclock",
    component: ShiftConfirm,
    meta: { title: "Vss - Time Clock" },
  },
  {
    name: "timeclockShiftConfirm",
    path: "/timeclock/shift_confirm",
    component: ShiftConfirm,
    meta: { title: "Vss - Time Clock | Confirm" },
  },
  {
    name: "timeclockPunch",
    path: "/timeclock/punch",
    component: Punch,
    meta: { title: "Vss - Time Clock | Punch in/out" },
  },
  {
    name: "employeeOwnWorkHistory",
    path: "/my-work-history",
    component: EmployeeOwnWorkHistory,
    meta: { title: "Vss - My Work History" },
  },
  // {
  //   name: 'calendar',
  //   path: '/calendar',
  //   component: Calendar,
  //   meta: { title: 'Vss - Calendar' }
  // },
  {
    name: "calendar",
    path: "/calendar/list",
    component: Calendar,
    meta: { title: "Vss - Calendar" },
  },
  {
    name: "month",
    path: "/calendar/month",
    component: MonthCalendar,
    meta: { title: "Vss - Calendar" },
  },
  {
    name: "shiftDetail",
    path: "/calendar/shift/:shiftId",
    component: ShiftDetail,
    meta: { title: "Vss - Calendar | Shift" },
    children: [
      {
        path: "detail",
        name: "shift/detail",
      },
      {
        path: "work-history",
        name: "shift/work-history",
      },
      {
        path: "record-history",
        name: "shift/record-history",
      },
      {
        path: "contact",
        name: "shift/contact",
      },
      {
        path: "shift-review",
        name: "shift/shift-review",
      },
      {
        path: "sar",
        name: "shift/sar",
      },
      {
        path: "trade-request",
        name: "shift/trade-request",
      },
    ],
  },
  {
    name: "messages",
    path: "/messages",
    component: Inbox,
    meta: { title: "VSS - Inbox" },
  },
  {
    name: "outbox",
    path: "/messages/sent",
    component: Outbox,
    meta: { title: "VSS - Sent" },
  },
  {
    name: "requests",
    path: "/messages/requests",
    component: Requests,
    meta: { title: "VSS - Requests" },
  },
  {
    name: "messageArchive",
    path: "/messages/archive",
    component: Inbox,
    meta: { title: "VSS - Archive" },
  },
  {
    name: "messageView",
    path: "/messages/:messageId",
    component: Inbox,
    meta: { title: "VSS - Inbox" },
  },
  {
    name: "clientEvaluationForm",
    path: "/client-evaluation/:shareKey",
    component: ClientEvaluationForm,
    meta: { title: "VSS - Client Evaluation" },
  },
  {
    name: "hrManagers",
    path: "/hr/managers",
    component: HrManagers,
    meta: { title: "Vss - HR | Managers" },
  },
  {
    name: "hrManagerDetail",
    path: "/hr/managers/:managerId",
    component: HrManagerDetail,
    meta: { title: "Vss - HR | Manager" },
  },
  {
    name: "hr",
    path: "/hr/employees",
    component: Hr,
    meta: { title: "Vss - HR | Employees" },
  },
  {
    name: "deactivatedEmployees",
    path: "/hr/deactivated-employees",
    component: DeactivatedEmployees,
    meta: { title: "Vss - HR | Deactivated Employees" },
  },
  {
    name: "employeeWatchListIndex",
    path: "/hr/employee-watch-lists",
    component: WatchListIndex,
    meta: { title: "Vss - HR | Watch Lists" },
  },
  {
    name: "employeeWatchList",
    path: "/hr/employee-watch-list/:listID",
    component: WatchListShow,
    meta: { title: "Vss - HR | Watch List" },
  },
  {
    name: "employeeNew",
    path: "/hr/employees/new",
    component: EmployeeCreate,
    meta: { title: "Vss - HR | New Employee" },
  },
  {
    name: "clientNew",
    path: "/hr/clients/new",
    component: ClientCreate,
    meta: { title: "Vss - HR | New Client" },
  },
  {
    name: "hrClients",
    path: "/hr/clients",
    component: HrClients,
    meta: { title: "Vss - HR | Clients" },
  },
  {
    name: "clientDetail",
    path: "/hr/clients/:clientId",
    component: ClientDetail,
    meta: { title: "Vss - HR | Client" },
  },
  {
    name: "locationNew",
    path: "/hr/locations/new",
    component: LocationCreate,
    meta: { title: "Vss - HR | New Location" },
  },
  {
    name: "clientBusinessNew",
    path: "/hr/client-businesses/new",
    component: ClientBusinessCreate,
    meta: { title: "Vss - HR | New Client Business" },
  },
  {
    name: "clientAdminLocations",
    path: "/hr/administered-locations",
    component: ReportsIndex,
    meta: { title: "Vss - HR | Administered Locations" },
  },
  {
    name: "hrClientBusinesses",
    path: "/hr/locations",
    component: HrClientBusinesses,
    meta: { title: "Vss - HR | Locations" },
  },
  {
    name: "clientBusinessDetail",
    path: "/hr/locations/:clientBusinessId",
    component: ClientBusinessDetail,
    meta: { title: "Vss - HR | Location" },
  },

  {
    name: "hrGeotags",
    path: "/hr/geotags",
    component: HrGeotags,
    meta: { title: "Vss - HR | Geotags" },
  },
  {
    name: "geoTagShow",
    path: "/hr/geotags/:tagID",
    component: GeoTagShow,
    meta: { title: "Vss - HR | Geotag" },
  },

  {
    name: "serviceNew",
    path: "/service/new",
    component: ServiceCreate,
    meta: { title: "Vss - Service | New" },
  },
  {
    name: "eventNew",
    path: "/event/new",
    component: EventCreate,
    meta: { title: "Vss - Event | New" },
  },
  {
    name: "eventIndex",
    path: "/events",
    component: EventIndex,
    meta: { title: "Vss - All Events" },
  },
  {
    name: "eventDetail",
    path: "/event/:eventId",
    component: EventShow,
    meta: { title: "Vss - Event" },
  },
  {
    name: "eventEdit",
    path: "/event/:eventId/edit",
    component: EventCreate,
    meta: { title: "Vss - Event | Edit" },
  },
  {
    name: "resources",
    path: "/hr/resources",
    component: Resources,
    meta: { title: "Vss - HR | Resources" },
  },
  {
    name: "employeeDetail",
    path: "/hr/employees/:employeeId",
    component: EmployeeDetail,
    meta: { title: "Vss - HR | Employee" },
    children: [
      {
        path: "top-sheet",
        name: "employee/top-sheet",
      },
      {
        path: "info",
        name: "employee/info",
      },
      {
        path: "experience",
        name: "employee/experience",
      },
      {
        path: "certifications",
        name: "employee/certifications",
      },
      {
        path: "admin",
        name: "employee/admin",
      },
      {
        path: "manage",
        name: "employee/manage",
      },
      {
        path: "personnel-history",
        name: "employee/personnel-history",
      },
      {
        path: "team",
        name: "employee/team",
      },
      {
        path: "schedule",
        name: "employee/schedule",
      },
      {
        path: "work-history",
        name: "employee/work-history",
      },
      {
        path: "contact",
        name: "employee/contact",
      },
    ],
  },
  {
    name: "reports",
    path: "/hr/reports",
    component: ReportsIndex,
    meta: { title: "Vss - HR | Reports" },
  },
  {
    name: "timeclockReports",
    path: "/hr/reports/timeclock",
    component: LocationTimeclockReports,
    meta: { title: "Vss - HR | Reports | Timeclock" },
  },
  {
    name: "certificationsReport",
    path: "/hr/reports/certifications",
    component: CertificationsReport,
    meta: { title: "Vss - HR | Reports | Certifications" },
  },
  {
    name: "taskReport",
    path: "/hr/reports/tasks",
    component: TaskReport,
    meta: { title: "Vss - HR | Reports | Tasks" },
  },
  {
    name: "geoReport",
    path: "/hr/reports/geo/:tagIDs",
    component: GeoReport,
    meta: { title: "Vss - HR | Reports | Geo" },
    props: (route) => ({
      tagIDs: route.params.tagIDs,
    }),
  },
  {
    name: "payrollReports",
    path: "/hr/reports/payroll",
    component: PayrollReports,
    meta: { title: "Vss - HR | Reports | Payroll" },
  },
  {
    name: "clientFulfillmentReport",
    path: "/hr/reports/clientFulfillmentReport",
    component: ClientFulfillmentReport,
    meta: { title: "Vss - HR | Reports | Client Fulfillment (mine)" },
  },
  {
    name: "clientLocationFulfillmentReport",
    path: "/hr/reports/clientLocationFulfillmentReport",
    component: ClientLocationFulfillmentReport,
    meta: { title: "Vss - HR | Reports | Client Fulfillment (location)" },
  },
  {
    name: "employeeShiftCountReport",
    path: "/hr/reports/employee-shift-count",
    component: EmployeeShiftCountReport,
    meta: { title: "Vss - HR | Reports | Employee Shift Count" },
  },
  {
    name: "managerFulfillmentReport",
    path: "/hr/reports/managerFulfillmentReport",
    component: ManagerFulfillmentReport,
    meta: { title: "Vss - HR | Reports | Manager Fulfillment" },
  },
  {
    name: "billingReports",
    path: "/hr/reports/billing",
    component: BillingReports,
    meta: { title: "Vss - HR | Reports | Billing" },
  },
  {
    name: "currentlyWorkingReport",
    path: "/hr/reports/currentlyWorking",
    component: CurrentlyWorkingReport,
    meta: { title: "Vss - HR | Reports | Currently Working" },
  },
  {
    name: "clientTimeOrderedReport",
    path: "/hr/reports/client-time-ordered",
    component: ClientTimeOrderedReport,
    meta: { title: "Vss - HR | Reports | Client Time Ordered" },
  },
  {
    name: "allTimeOrderedReport",
    path: "/hr/reports/all-time-ordered",
    component: AllTimeOrderedReport,
    meta: { title: "Vss - HR | Reports | All Time Ordered" },
  },
  {
    name: "employeeHoursAtClient",
    path: "/hr/reports/employee-hours-at-client",
    component: EmployeeHoursAtClientReport,
    meta: { title: "Vss - HR | Reports | Employee Hours at Client" },
  },
  {
    name: "employeeHours",
    path: "/hr/reports/employee-time-worked",
    component: EmployeeHours,
    meta: { title: "Vss - HR | Reports | Employee Time Worked" },
  },
  {
    name: "referralReport",
    path: "/hr/reports/referrals",
    component: ReferralReport,
    meta: { title: "Vss - HR | Reports | Referrals" },
  },
  {
    name: "commLogReport",
    path: "/hr/reports/employee-comm-log",
    component: CommLogReport,
    meta: { title: "Vss - HR | Reports | Employee Comm Log" },
  },
  {
    name: "ipAddressLogReport",
    path: "/hr/reports/employee-ipaddress-log",
    component: IPAddressLogReport,
    meta: { title: "Vss - HR | Reports | Employee IP Address Log" },
  },
  {
    name: "cancelledShifts",
    path: "/hr/reports/cancelled-shifts",
    component: CancelledShifts,
    meta: { title: "Vss - HR | Reports | Cancelled Shifts" },
  },
  {
    name: "birthdaysAnniversaries",
    path: "/hr/reports/birthdays-anniversaries",
    component: BirthdaysAnniversaries,
    meta: { title: "Vss - HR | Reports | Birthdays & Anniversaries" },
  },
  {
    name: "contactReport",
    path: "/hr/reports/contact-report",
    component: ContactReport,
    meta: { title: "Vss - HR | Reports | Contact" },
  },
  {
    name: "settingsIndex",
    path: "/settings",
    component: SettingsIndex,
    meta: { title: "Vss - Settings" },
  },
  {
    name: "settingsHolidays",
    path: "/settings/holidays",
    component: SettingsHolidays,
    meta: { title: "Vss - Settings | Holidays" },
  },
  {
    name: "settingsCallin",
    path: "/settings/callin",
    component: SettingsCallin,
    meta: { title: "Vss - Settings | Call-in" },
  },
  {
    name: "settingsBulletins",
    path: "/settings/bulletins",
    component: SettingsBulletins,
    meta: { title: "Vss - Settings | Bulletins" },
  },
  {
    name: "worksiteShow",
    path: "/worksites/:worksiteId",
    component: WorksiteShow,
    meta: { title: "Vss - Worksite" },
  },
  {
    name: "coordinatedCoverageRequestShow",
    path: "/coordinated-coverage-requests/:coordinatedCoverageRequestId",
    component: CoordinatedCoverageRequestContainer,
    meta: { title: "Vss - Coordinated Coverage Request" },
  },
  {
    name: "myTodoList",
    path: "/todos/mine",
    component: MyTodos,
    meta: { title: "Vss - My Tasks" },
  },
  {
    name: "managedTodoLists",
    path: "/todos/managed",
    component: ManagedTodos,
    meta: { title: "Vss - Managed Tasks" },
  },

  {
    name: "smsIndex",
    path: "/sms",
    component: SMSIndex,
    meta: { title: "Vss - SMS" },
  },

  // {
  //   name: 'timeclockLocationReports',
  //   path: '/hr/reports/timeclock_at',
  //   component: LocationTimeclockReports,
  //   meta: { title: 'Vss - HR | Reports | Timeclock for Location' }
  // },
];


/*
This error is safe to ignore and is interfering with Sentry error reporting

Work-around: https://stackoverflow.com/questions/65878999/vue-router-push-error-avoided-redundant-navigation-to-current-location
Alternatives: https://www.zipy.ai/blog/debug-vue-js-vue-router-errors
*/
const { isNavigationFailure, NavigationFailureType } = VueRouter;
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  originalPush.call(this, location).catch(error => {
    if (!isNavigationFailure(error, NavigationFailureType.duplicated)) {
      throwError(error);
    }
  })
}

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.open)) {
    next();
  } else {
    store.dispatch("userAuth/getTokenFromStorage");
    if (store.getters["userAuth/isLoggedIn"]) {
      next();
      return;
    } else {
      next("/login");
    }
  }
});

router.afterEach((to, from) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = "Vss";
  }
});

export default router;
